import { DescriptionPage_ProductVariant as DescriptionPageProductVariant } from '__generated__/graphql-types';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { PROF_CERTS_USING_SKILL_CERT_LABEL } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

const getProductTitle = (name: string, productVariant?: DescriptionPageProductVariant, slug?: string) => {
  if (productVariant && productVariant === DescriptionPageProductVariant.StandardSpecialization) {
    return _t('#{name} Specialization', { name });
  } else if (
    slug &&
    productVariant &&
    productVariant === DescriptionPageProductVariant.ProfessionalCertificate &&
    PROF_CERTS_USING_SKILL_CERT_LABEL.includes(slug) &&
    GrowthDiscoveryEpicClient.preview('useSkillCertificatePCDPLabel')
  ) {
    return _t('#{name} Skill Certificate', { name });
  } else if (
    productVariant &&
    (productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
      productVariant === DescriptionPageProductVariant.GoogleCertificate)
  ) {
    return _t('#{name} Professional Certificate', { name });
  }

  return name;
};

export default getProductTitle;
